var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlueBackgroundWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13,
    r: 10,
    fill: "#FDFDFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20312 18.0767H11.1136V14.2273H14.9631V12.3168H11.1136V8.47443H9.20312V12.3168H5.3608V14.2273H9.20312V18.0767Z",
    fill: "#508CC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlueBackgroundWhite);
export default __webpack_public_path__ + "static/media/plus-blue-background-white.0fecb9d0bd260c64c349ffa3dbd1dc38.svg";
export { ForwardRef as ReactComponent };